

import React, { useMemo, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import AdminMaster from '../../../Layout/admin/Master';
import { Toast, ToastContainer, OverlayTrigger, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

import { useFormik } from 'formik';
import { BiReset, BiSearch } from 'react-icons/bi';
import { getUserlist, getUserManualAssign } from '../../../Redux/qms/action';
import moment from 'moment';

import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import Select, { components } from 'react-select';
import { getAllClientDropdown } from '../../../Redux/client/action';
import 'rsuite/dist/rsuite.min.css';
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import DateRangePicker from 'rsuite/DateRangePicker';
import { HiChevronDown } from 'react-icons/hi';
import { TbGridDots } from 'react-icons/tb';
import { Tooltip } from '@mui/material';
import { ExportUserActivitylog, getUserActivitylog } from '../UserActivity/index';
import { PiExportBold } from 'react-icons/pi';
import { downloadFile } from '../Dashboard/functions';


const UserActivityLog = () => {
    const [datetime, setDateTime] = useState([]);


    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [data, setData] = useState({})
    const [colorRow, setColorRow] = React.useState({});



    const [pageno, setPageNo] = useState(1);
    const [userlist, setUserlist] = useState();

    const [toaster, setToaster] = useState(null);

    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })

    useEffect(() => {
        getUserlist(1)((response) => {
            setUserlist(response?.data?.results)
        });

    }, []);


    const predefinedBottomRanges = [
        {
            label: 'Today',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
            placement: 'left'
        },
        {
            label: 'Yesterday',
            value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
            placement: 'left'
        },
        {
            label: 'This week',
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: 'left'
        },
        {
            label: 'Last 7 days',
            value: [subDays(new Date(), 6), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 30 days',
            value: [subDays(new Date(), 29), new Date()],
            placement: 'left'
        },
        {
            label: 'This month',
            value: [startOfMonth(new Date()), new Date()],
            placement: 'left'
        },
        {
            label: 'Last month',
            value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
            placement: 'left'
        },
        {
            label: 'This year',
            value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
            placement: 'left'
        },
        {
            label: 'Last year',
            value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
            placement: 'left'
        },

        {
            label: 'Last week',
            closeOverlay: false,
            value: value => {
                const [start = new Date()] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
                ];
            },
            appearance: 'default'
        },
        {
            label: 'Next week',
            closeOverlay: false,
            value: value => {
                const [start = new Date()] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
                ];
            },
            appearance: 'default'
        }
    ];

    const handleDownloadSftpLog = (file) => {
        const fileURL = file;

        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'SamplePDF.pdf';
        alink.target = '_blank';
        alink.click();
        fetchQueueListing(pageno, limit, searchedData)
    }

    const columns = useMemo(
        () => [
            {
                id: 'id',
                name: 'S NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                // sortable: false,
                wrap: true,
                width: "50px",
                grow: 0,

            },


            {
                id: 'user',
                name: 'Username',
                selector: row => row.created_by,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        <span className='text-truncate '>
                            {row?.created_by}
                        </span>
                    </div>
                ,
                wrap: true,
                sortable: false,
                width: "100px",

            },

            {
                id: 'affected_username',
                name: 'Target name',
                selector: row => row.affected_username,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{width: "130px" }}>
                        <Tooltip disableInteractive title={row?.affected_username} placement='top' arrow>
                            <span className='text-truncate '>
                                {row?.affected_username}
                            </span>
                        </Tooltip>
                    </div>
                ,
                wrap: true,
                sortable: false,
                width: "130px",

            },
            {
                id: 'module_name',
                name: 'Module',
                sort_key: "module_name",
                selector: row => row?.module_name,
                cell: (row, index) => <div>
                    {row?.module_name &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{ width: "140px" }}>
                            <Tooltip disableInteractive title={row?.module_name} placement='top' arrow>
                                {row?.module_name &&
                                    <span key={index} className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.module_name)}>{row?.module_name}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
                ,
                sortable: false,
                reorder: true,
                left: true,
                wrap: true,
                width: "140px",

            },
            {
                id: 'action_type',
                name: 'Action Type',
                sort_key: "action_type",
                selector: row => row?.action_type,
                cell: (row, index) => <div>
                    {row?.action_type &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{ width: "120px" }}>
                            <Tooltip disableInteractive title={row?.action_type} placement='top' arrow>
                                {row?.action_type &&
                                    <span key={index} className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.action_type)}>{row?.action_type}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
                ,
                sortable: false,
                reorder: true,
                left: true,
                wrap: true,
                width: "140px",

            },
            {
                id: 'created_date',
                name: 'created date',
                selector: row => row.created_date,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)}>
                        <span className='text-truncate '>
                            {moment(row?.created_date).format('M/DD/YY, H:mm')}
                        </span>
                    </div>
                ,
                wrap: true,
                sortable: false,
                width: "110px",

            },
            {
                id: 'meta_data',
                name: 'Meta Data',
                sort_key: "meta_data",
                selector: row => row?.meta_data,
                cell: (row, index) => <div>
                    {row?.meta_data &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{ width: "450px" }}>
                            <Tooltip disableInteractive title={row?.meta_data} placement='top' arrow>
                                {row?.meta_data &&
                                    <span key={index} className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.meta_data)}>{row?.meta_data}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
                ,
                sortable: false,
                reorder: true,
                left: true,
                wrap: true,
                width: "500px",

            },
               {
                id: 'reference_number',
                name: 'Reference number',
                selector: row => row.reference_number,
                cell: (row) =>
                    <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{width: "130px" }}>
                        <Tooltip disableInteractive title={row?.reference_number} placement='top' arrow>
                            <span className='text-truncate '>
                                {row?.reference_number}
                            </span>
                        </Tooltip>
                    </div>
                ,
                wrap: true,
                sortable: false,
                width: "130px",

            },
            {
                id: 'comments',
                name: 'Comments',
                sort_key: "comments",
                selector: row => row?.comments,
                cell: (row, index) => <div>
                    {row?.comments &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{ width: "200px" }}>
                            <Tooltip disableInteractive title={row?.comments} placement='top' arrow>
                                {row?.comments &&
                                    <span key={index} className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.comments)}>{row?.comments}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
                ,
                sortable: false,
                reorder: true,
                left: true,
                wrap: true,
                width: "130px",

            },
            {
                id: 'edit',
                name: 'Action',

                cell: (row) =>
                    <React.Fragment>
                        <div>
                            <div className=" d-flex flex-row gap-2  justify-content-start align-items-center no-wrap" onClick={() => handleRowClick(row)}>


                                <div className=''>

                                    <Tooltip disableInteractive title="Log File" placement='top' arrow>
                                        <button className='btn fs-7 fw-bold btn-sm' onClick={() => { handleDownloadSftpLog(row.log_file) }} >
                                            <i className='bi bi-download fs-6' ></i>
                                        </button>
                                    </Tooltip>
                                </div>


                            </div>
                        </div>

                    </React.Fragment>
                ,
                ignoreRowClick: false,
                width: '130px',
                allowOverflow: true,
                right: true
            },

        ],
        [pageno, loading],
    );



    const fetchQueueListing = async (page, limit, params = {}) => {
        setLoading(true);
        const { created_by, module_name, created_date, affected_username } = params;
        getUserActivitylog({ page, limit, created_by, module_name, created_date, affected_username })((response) => {
            if (response?.status) {
                setData(response?.data);
                setPageNo(page);
                setLimit(limit);
                setTotalRows(response?.data?.count);
                setLoading(false);
            }
        });
    };
    const handlePageChange = page => {
        setPageNo(page)

        fetchQueueListing(page, limit, searchedData);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchQueueListing(1, newPerPage, searchedData)
        setLimit(newPerPage)
        handleResetDataTable()
    };
    useEffect(() => {
        fetchQueueListing(1, limit, searchedData)

    }, []);


    const [searchedData, setSearchedData] = useState({
        created_by: "",
        created_date: "",
        module_name: "",
        affected_username: "",
    })
    const [reRenderDataTable, setRerenderDataTable] = useState(false)
    const options = [
        { value: 'Users', label: 'Users' },
        { value: 'Roles', label: 'Roles' },
        { value: "Groups", label: "Groups" },
        { value: "Userwise DBK", label: "Userwise DBK" },
    ];
    const handleResetDataTable = () => {
        setRerenderDataTable(true)
        setTimeout(() => setRerenderDataTable(false), 200);
    }



    const handleExportUserActivity = () => {
        setExportLoading(true);
        let header_names = [];

        const headerMap = {
            created_by: "CREATED BY",
            affected_username: "TARGET NAME",
            module_name: "MODULE NAME",
            action_type: "ACTION TYPE",
            created_date: "CREATED DATE & TIME",
            meta_data: "META DATA",
            reference_number: "REFERENCE NUMBER",
            comments: "COMMENTS",

        };


        Object.values(headerMap).forEach(name => header_names.push(name));

        ExportUserActivitylog({
            created_by: searchedData?.created_by,
            created_date: searchedData?.created_date,
            module_name: searchedData?.module_name,
            affected_username: searchedData?.affected_username,
            header_names,

        })((response) => {
            setExportLoading(false);
            if (response?.data) {
                downloadFile(response.data, null, true);
            } else {
                setToastMessage({
                    status: true,
                    message: "No data to export",
                    type: "warning"
                });
            }
        });
        
    };

    const handleSelectChange = async (e) => {
        queueformik.setValues({ ...queueformik.values, module_name: e?.value ? e?.value : "" })
    }
    const queueformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            created_by: '',
            created_date: "",
            module_name: "",
            affected_username: "",

        },

        onSubmit: (values) => {

            fetchQueueListing(1, limit, values)
            setSearchedData({
                created_by: values?.created_by ? values?.created_by : "",
                created_date: values?.created_date ? values?.created_date : "",
                module_name: values?.module_name ? values?.module_name : "",
                affected_username: values?.affected_username ? values?.affected_username : "",
            })
            handleResetDataTable()
        },

    });

    const handleRowSelected = React.useCallback(state => {
        var ids = [];
        state.selectedRows.map((row, index) => {
            ids.push(row.id);
        })
        setSelectedRows(ids);
    }, []);

    const handleOnDateTimeChange = ({ name, value }) => {
        let created_date = ""
        if (value !== null) {
            const datefrom = moment(value['0']).format('MM/DD/YYYY HH:mm:ss')
            const dateto = moment(value['1']).format('MM/DD/YYYY HH:mm:ss')

            created_date = datefrom + " - " + dateto
        }
        setDateTime(created_date)

        queueformik.setValues({ ...queueformik.values, created_date, deposit_date_range: value ?? "" })


    }


    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.pk == row.pk ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.pk == row.pk ? '#dbf4f5' : '#f2f2f2',
            }),
        },

    ];
    const handleRowClick = (row) => {
        setColorRow(row);
        // // console.log(row);
    };

    const handleRowCheckClick = (row) => {
        data?.results.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
        // // console.log(row);
    };
    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {queueformik.values[state]?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}



            </components.DropdownIndicator>
        );
    };

    const [isFocusedUsers, setIsFocusedUsers] = useState(false);
    const formatOptionLabel = ({ value, label, is_logged_in }) => (
        <div className='d-flex flex-row justify-content-between align-items-center'>
            <div>{label}</div>
            {is_logged_in ?
                <div className='ms-2 dot' />

                :
                <div></div>
            }
        </div>
    );

    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />

            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header ">
                    <h1 id='page-title'>User Activity Logs</h1>
                </div>

                <ToastContainer className="p-3" position={"top-end"}>
                    <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                        {
                            status: false,
                            message: "",
                            type: "",
                        }

                    )}
                        show={ToastMessage?.status} animation={true} delay={2000} autohide>
                        <Toast.Body ><span className='text-white'>{ToastMessage?.message}</span></Toast.Body>
                    </Toast>

                </ToastContainer>

                <section className="section mt-5">
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">
                                <Form onSubmit={queueformik.handleSubmit} onReset={() => {
                                    window.location.reload()
                                }}>
                                    <div className='' >
                                        <div className="d-flex flex-row justify-content-start gap-2 align-items-center px-4 py-4 flex-wrap py-3">
                                            <div style={{ width: '18%' }} >

                                                <Select
                                                    isMulti
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    options={userlist}
                                                    isClearable
                                                    formatOptionLabel={formatOptionLabel}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="created_by" /> }}
                                                    className="select-search-job-monitor"
                                                    classNamePrefix="select"
                                                    placeholder=" User"
                                                    name="created_by"
                                                    onFocus={() => setIsFocusedUsers(true)}
                                                    onBlur={() => setIsFocusedUsers(false)}
                                                    onChange={(e) => queueformik.setValues({ ...queueformik.values, created_by: e?.map(i => i.value) })}
                                                    // value={getMultiSelectedValues(userlist, queueformik?.values?.created_by)}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px",
                                                        }),

                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedUsers ? "auto" : "30px",
                                                        }),
                                                    }}
                                                />

                                            </div>

                                            <Tooltip disableInteractive title="Created Date" placement='top' arrow>


                                                <div className='' >
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">

                                                        <DateRangePicker
                                                            ranges={predefinedBottomRanges}
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            cleanable={true}
                                                            appearance="default"
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                            name="deposit_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'deposit_date_range', value: e }) }}
                                                        //  value={queueformik?.values?.deposit_date_range} 
                                                        />

                                                    </Stack>
                                                </div>
                                            </Tooltip>
                                            <div className="">
                                                <Select
                                                    isClearable
                                                    options={options}
                                                    className="select-search-approve"
                                                    classNamePrefix="select"
                                                    placeholder="Module"
                                                    name="module"
                                                    onChange={handleSelectChange}
                                                    styles={{ control: (styles) => ({ ...styles, backgroundColor: "hsl(204deg 33.33% 97.06%)", borderStyle: "none", boxShadow: "none", borderRadius: "10px" }), indicatorSeparator: styles => ({ ...styles, width: "0px", minHeight: "20px" }), container: styles => ({ ...styles, borderRadius: "9px", }) }}
                                                />
                                            </div>

                                            <div className="">
                                                <Form.Control
                                                    id="search"
                                                    className="form-control form-control-solid fileManagePadding b-r-10"
                                                    onChange={queueformik.handleChange}
                                                    name="affected_username"
                                                    type="search"
                                                    placeholder="Target Name"
                                                    value={queueformik.values?.affected_username}
                                                    style={{fontSize:'14px'}}
                                                />
                                            </div>

                                            <div className='' style={{ width: '' }}>
                                                <div className='d-flex justify-content-start gap-2'>
                                                    <Tooltip disableInteractive title="Search" placement='top' arrow>
                                                        <Button disabled={loading} className="btn btn-light btn-active-primary  " type="submit">
                                                            <span className="svg-icon svg-icon-3">
                                                                <BiSearch />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip disableInteractive title="Reset" placement='top' arrow>
                                                        <Button className="btn btn-light btn-active-primary " type='reset' >
                                                            <span className="svg-icon svg-icon-3">
                                                                <BiReset />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip disableInteractive title="Export" placement='top' arrow>
                                                        <Button className="btn btn-light btn-active-primary " onClick={handleExportUserActivity} disabled={exportLoading}>
                                                            {exportLoading ? (
                                                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                </div>
                                                            ) : (
                                                                <span className="svg-icon svg-icon-3">
                                                                    <PiExportBold />
                                                                </span>
                                                            )}
                                                        </Button>
                                                    </Tooltip>


                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </Form>
                                <div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}
                                                    data={data?.results}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    onSelectedRowsChange={handleRowSelected}
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    pointerOnHover
                                                    customStyles={queueDatatableCustomStyles}
                                                    responsive={true}
                                                // onSort={handleSort}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

        </React.Fragment>
    )
}

export default UserActivityLog;